// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bank-account-drawer .ant-carousel,
.bank-account-drawer .slick-slider.slick-initialized,
.bank-account-drawer .slick-list,
.bank-account-drawer .slick-track,
.bank-account-drawer .ant-drawer-body,
.bank-account-drawer .drawer-body {
  height: 100%;
}
.bank-account-drawer .gyramais-alert {
  margin-bottom: 2.5rem;
}
.bank-account-drawer .ant-form-item {
  margin-bottom: 2rem;
}
.bank-account-drawer .tutorial-step-title {
  color: var(--link-button-color);
}
.bank-account-drawer .slick-slide.slick-active.slick-current {
  height: 100%;
  overflow: auto;
}
.bank-account-drawer .top-side {
  padding: 2.5rem 0;
}
@media (max-width: 768px) {
  .bank-account-drawer .top-side {
    padding: 1rem 0;
    padding-top: 1.5rem;
  }
}
.bank-account-drawer .bank-form-section {
  padding: 2rem 5rem;
}
@media (max-width: 768px) {
  .bank-account-drawer .bank-form-section {
    padding: 1rem;
  }
}
.bank-account-drawer .ant-drawer-body {
  overflow-x: hidden !important;
  padding: 0 !important;
}
.bank-account-drawer .ant-drawer-body .open-helper-button-col {
  display: none !important;
}
@media (max-width: 768px) {
  .bank-account-drawer .ant-drawer-body .open-helper-button-col {
    display: inherit !important;
  }
}
.bank-account-drawer .ant-drawer-body .open-helper-button-col .open-helper-button {
  margin-bottom: 1.5rem;
}
.bank-account-drawer .ant-drawer-body .close-button .close-icon {
  margin-right: 0.65rem;
}
.bank-account-drawer .ant-drawer-body .drawer-body .bank-select-section {
  overflow-x: hidden;
}
.bank-account-drawer .ant-drawer-body .drawer-body .carousel-row:not(.no-padding) {
  padding: 2rem 5rem;
}
@media (max-width: 768px) {
  .bank-account-drawer .ant-drawer-body .drawer-body .carousel-row:not(.no-padding) {
    padding: 1rem;
  }
}
.bank-account-drawer .ant-drawer-footer {
  padding: 1.25rem 3.75rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #ffffff;
  border-top: 0.063rem solid #00000028;
}
@media (max-width: 768px) {
  .bank-account-drawer .ant-drawer-footer {
    padding: 1rem;
    justify-content: center;
  }
  .bank-account-drawer .ant-drawer-footer .gyramais-btn {
    width: 100%;
  }
}
.helper-area {
  background-color: #EDEEEE;
}
`, "",{"version":3,"sources":["webpack://./src/components/drawers/BankAccountDrawer/styles.less"],"names":[],"mappings":"AAAA;;;;;;EAQI,YAAA;AADJ;AAPA;EAYI,qBAAA;AAFJ;AAVA;EAgBI,mBAAA;AAHJ;AAbA;EAoBI,+BAAA;AAJJ;AAhBA;EAwBI,YAAA;EACA,cAAA;AALJ;AApBA;EA6BI,iBAAA;AANJ;AAQI;EAAA;IACE,eAAA;IACA,mBAAA;EALJ;AACF;AA7BA;EAsCI,kBAAA;AANJ;AAQI;EAAA;IACE,aAAA;EALJ;AACF;AArCA;EA8CI,6BAAA;EACA,qBAAA;AANJ;AAzCA;EAmDM,wBAAA;AAPN;AASM;EAAA;IACE,2BAAA;EANN;AACF;AAjDA;EA0DQ,qBAAA;AANR;AApDA;EAgEQ,qBAAA;AATR;AAvDA;EAsEQ,kBAAA;AAZR;AA1DA;EA0EQ,kBAAA;AAbR;AAeQ;EAAA;IACE,aAAA;EAZR;AACF;AAlEA;EAoFI,wBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;AAfJ;AAiBI;EAAA;IACE,aAAA;IACA,uBAAA;EAdJ;EAYE;IAKI,WAAA;EAdN;AACF;AAmBA;EACE,yBAAA;AAjBF","sourcesContent":[".bank-account-drawer {\n  // corrige scroll para o limpo\n  .ant-carousel,\n  .slick-slider.slick-initialized,\n  .slick-list,\n  .slick-track,\n  .ant-drawer-body,\n  .drawer-body {\n    height: 100%;\n  }\n\n  .gyramais-alert {\n    margin-bottom: 2.5rem;\n  }\n\n  .ant-form-item {\n    margin-bottom: 2rem;\n  }\n\n  .tutorial-step-title {\n    color: var(--link-button-color);\n  }\n  // corrige scroll para o limpo\n  .slick-slide.slick-active.slick-current {\n    height: 100%;\n    overflow: auto;\n  }\n\n  .top-side {\n    padding: 2.5rem 0;\n\n    @media (max-width: @md-screen) {\n      padding: 1rem 0;\n      padding-top: 1.5rem;\n    }\n  }\n\n  .bank-form-section {\n    padding: 2rem 5rem;\n\n    @media(max-width: @md-screen) {\n      padding: 1rem;\n    }\n  }\n\n  .ant-drawer-body {\n    overflow-x: hidden !important;\n    padding: 0 !important;\n\n    .open-helper-button-col {\n      // somente aparecer no mobile\n      display: none !important;\n\n      @media(max-width: @md-screen) {\n        display: inherit !important;\n      }\n\n      .open-helper-button {\n        margin-bottom: 1.5rem;\n      }\n    }\n\n    .close-button {\n      .close-icon {\n        margin-right: .65rem;\n      }\n    }\n\n    .drawer-body {\n      .bank-select-section {\n        overflow-x: hidden;\n      }\n\n      .carousel-row:not(.no-padding) {\n        padding: 2rem 5rem;\n\n        @media(max-width: @md-screen) {\n          padding: 1rem;\n        }\n      }\n    }\n  }\n\n  .ant-drawer-footer {\n    padding: 1.25rem 3.75rem;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    background-color: #ffffff;\n    border-top: .063rem solid #00000028;\n\n    @media(max-width: @md-screen) {\n      padding: 1rem;\n      justify-content: center;\n\n      .gyramais-btn {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.helper-area {\n  background-color: #EDEEEE;\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
